// extracted by mini-css-extract-plugin
export var configurationSection = "_s0-0";